import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { ActionTypes } from '../constants/actionTypes.js';
import { JsonApiRecordDecorator } from '../json-api/JsonApiRecordDecorator.js';
import { API_READ, API_READ_FAILED } from 'redux-json-api/lib/constants';
import { reducer } from 'redux-json-api';

var clearLoadingEntities = function clearLoadingEntities(action, newState) {
  if (action.payload.endpoint && newState.loadingEntities) {
    Object.keys(newState.loadingEntities).forEach(function (key) {
      if (key === action.payload.endpoint) {
        delete newState.loadingEntities[key];
      }
    });
  }
};

function ApiReducer(state) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var newState = Object.assign({}, state);
  var actionTypeToStateMap = {};

  actionTypeToStateMap[ActionTypes.SET_CURRENT_ENTITY_VALUES] = function () {
    var currentEntity = Object.assign(new JsonApiRecordDecorator(), state.currentEntity, action.values);
    return Object.assign({}, state, {
      currentEntity: currentEntity
    });
  };

  actionTypeToStateMap[ActionTypes.CREATE_CURRENT_ENTITY] = function () {
    var currentEntity = new JsonApiRecordDecorator();
    currentEntity.type = action.entityType;

    if (action.defaultValues) {
      Object.assign(currentEntity, action.defaultValues);
    }

    return Object.assign({}, state, {
      currentEntity: currentEntity,
      currentEntityType: action.entityType
    });
  };

  actionTypeToStateMap[ActionTypes.SELECT_ENTITY] = function () {
    return Object.assign({}, state, {
      currentEntityId: action.entityId,
      currentEntityType: action.entityType
    });
  };

  actionTypeToStateMap[ActionTypes.LAST_SELECTED_ENTITY] = function () {
    return Object.assign({}, state, {
      lastSelectedEntity: action.entityId
    });
  };

  actionTypeToStateMap[ActionTypes.LAST_CREATED_ENTITY] = function () {
    return Object.assign({}, state, {
      lastCreatedEntity: action.entityId
    });
  };

  actionTypeToStateMap[ActionTypes.CLEAR_LAST_SELECTED_ENTITY] = function () {
    delete newState.lastSelectedEntity;
    delete newState.lastCreatedEntity;
    return newState;
  };

  actionTypeToStateMap[ActionTypes.SET_ACTIVE_PAGE] = function () {
    return Object.assign({}, state, {
      activePage: action.activePage
    });
  };

  actionTypeToStateMap[ActionTypes.SET_ACTIVE_FILTERS] = function () {
    return Object.assign({}, state, {
      activeFilters: action.filters
    });
  };

  actionTypeToStateMap[ActionTypes.SET_ACTIVE_SORT] = function () {
    return Object.assign({}, state, {
      activeSort: action.sort
    });
  };

  actionTypeToStateMap[ActionTypes.SET_ACTIVE_SEARCH] = function () {
    return Object.assign({}, state, {
      activeSearch: action.search
    });
  };

  actionTypeToStateMap[ActionTypes.SET_ACTIVE_STATE] = function () {
    return Object.assign({}, state, {
      activeState: action.state
    });
  };

  actionTypeToStateMap[ActionTypes.RESET_ACTIVE_PROPS] = function () {
    return Object.assign({}, state, {
      activePage: undefined,
      activeFilters: undefined,
      activeSort: undefined,
      activeSearch: undefined,
      activeState: undefined
    });
  };

  actionTypeToStateMap[ActionTypes.START_DOWNLOAD] = function () {
    return Object.assign({}, state, {
      downloadProcessing: true,
      downloadTimedOut: false
    });
  };

  actionTypeToStateMap[ActionTypes.DOWNLOAD_SUCCESS] = function () {
    return Object.assign({}, state, {
      downloadProcessing: false,
      downloadUrl: action.downloadUrl
    });
  };

  actionTypeToStateMap[ActionTypes.DOWNLOAD_FAIL] = function () {
    return Object.assign({}, state, {
      downloadProcessing: false,
      errorMessage: action.errorMessage
    });
  };

  actionTypeToStateMap[ActionTypes.REPORT_TIMEOUT] = function () {
    return Object.assign({}, state, {
      downloadProcessing: false,
      downloadTimedOut: true
    });
  };

  actionTypeToStateMap[ActionTypes.END_TIMEOUT] = function () {
    return Object.assign({}, state, {
      downloadProcessing: false,
      downloadTimedOut: false
    });
  };

  actionTypeToStateMap[ActionTypes.CLEAR_MESSAGES] = function () {
    delete newState.errorMessage;
    delete newState.successMessage;
    delete newState.errorMessages;
    return newState;
  };

  actionTypeToStateMap[ActionTypes.DISPLAY_ERROR] = function () {
    return Object.assign({}, state, {
      errorMessage: action.message
    });
  };

  actionTypeToStateMap[ActionTypes.DISPLAY_ERRORS] = function () {
    return Object.assign({}, state, {
      errorMessages: action.errors
    });
  };

  actionTypeToStateMap[ActionTypes.DISPLAY_SUCCESS] = function () {
    return Object.assign({}, state, {
      successMessage: action.message
    });
  };

  actionTypeToStateMap[ActionTypes.CLEAR_API_STATE] = function () {
    delete newState[action.entity];
    delete newState.downloadUrl;
    return newState;
  };

  actionTypeToStateMap[ActionTypes.ENTITY_WILL_READ] = function () {
    var entities = Object.assign({}, state.loadingEntities, _defineProperty({}, action.endpoint, action.entity));
    return Object.assign({}, state, {
      loadingEntities: entities
    });
  };

  actionTypeToStateMap[ActionTypes.DELETE_ENTITY] = function () {
    var _newState$action$enti;

    if ((_newState$action$enti = newState[action.entityType]) !== null && _newState$action$enti !== void 0 && (_newState$action$enti = _newState$action$enti.meta) !== null && _newState$action$enti !== void 0 && _newState$action$enti.total_count) {
      newState[action.entityType].meta.total_count -= 1;
    }

    return newState;
  };

  actionTypeToStateMap[API_READ] = function () {
    newState = reducer(state, action);

    if (action.payload.data && action.payload.data[0]) {
      newState[action.payload.data[0].type].meta = action.payload.meta;
    }

    clearLoadingEntities(action, newState);
    return newState;
  };

  actionTypeToStateMap[API_READ_FAILED] = function () {
    newState = reducer(state, action);
    clearLoadingEntities(action, newState);
    return newState;
  };

  if (Object.hasOwnProperty.call(actionTypeToStateMap, action.type)) {
    return actionTypeToStateMap[action.type]();
  }

  return reducer(state, action);
}
/* backward compatibility */


var api = ApiReducer;
export { ApiReducer, api };